import React from "react";
import { Link as GatsbyLink } from "gatsby";
import classNames from "classnames";
import { ArrowRightIcon } from "@heroicons/react/20/solid";

const buttonClasses = ({ color, size, arrow }) => {
  const sizeClasses = {
    "text-lg": size === "large",
    "text-base": !size || size == "medium",
    "text-sm": size == "small",
  };

  const standardClasses = {
    "text-blue-500 hover:text-blue-300 underline":
      !color || color === "primary",
    "textyellow-500 hover:text-yellow-300 underline": color === "secondary",
  };

  let buttonClasses = { ...sizeClasses };

  buttonClasses = { ...buttonClasses, ...standardClasses };

  return classNames({
    "flex-inline": !arrow,
    flex: arrow,
    "justify-center items-center font-medium transition-colors duration-200":
      true,
    ...buttonClasses,
  });
};

type Props = {
  children: any;
  to: string;
  arrow?: any;
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary";
} & Omit<React.ComponentProps<typeof GatsbyLink>, "ref">;

export const Link = ({
  children,
  color,
  size,
  to,
  onClick,
  arrow,
  target,
  ...props
}: Props) => {
  return (
    <GatsbyLink
      to={to}
      target={target}
      onClick={onClick}
      className={buttonClasses({ color, size, arrow })}
      {...props}
    >
      {children} {arrow && <ArrowRightIcon className="h-4 ml-2" />}
    </GatsbyLink>
  );
};
